import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, useHistory } from 'react-router-dom';
import { NAME_SPACE } from 'i18n';
import { FormPage, useRequestLoading, ButtonSave, ButtonBack } from 'shared';
import { PATH } from 'app.routes.const';
import { FormReader } from './FormReader';
import { useReader } from './useReader';

export function EditReader() {
  const { id } = useParams();
  const { reader, createReader, updateReader, errorInfo, setErrorInfo } = useReader(id);
  const { t } = useTranslation(NAME_SPACE.READERS);
  const $formRef = useRef(null);
  const history = useHistory();
  const { requestLoading, callbackRequest } = useRequestLoading();

  async function handleSubmit(reader) {
    await callbackRequest(async () => {
      setErrorInfo({ message: '', detail: '' });
      id ? await updateReader(reader) : await createReader(reader);
      history.push(PATH.READERS.LIST);
    });
  }

  function handleSaveClick() {
    $formRef.current.submit();
  }

  function handleGoBack() {
    history.push(PATH.READERS.LIST);
  }

  function composeActionButtons() {
    const actionButtons = [
      { onClick: handleGoBack, component: ButtonBack },
      {
        onClick: handleSaveClick,
        enableOnDirty: true,
        component: ButtonSave
      }
    ];

    return actionButtons;
  }

  return (
    <FormPage
      title={t('singularName')}
      disabled={requestLoading}
      buttons={composeActionButtons()}
      onSubmit={handleSubmit}
    >
      <FormReader errors={errorInfo} formRef={$formRef} reader={{ ...reader }} />
    </FormPage>
  );
}
